/*
Controller for interface "Patterns" (context: "RAP4"). Generated code, edit with care.
Generated using template: interface.controller.js
Generated by Ampersand-v4.7.7 [2ec5b6dbd933f24fb7a1cce1ed63a1c8c55229ed:refs/tags/v4.7.7], build time: 28-Nov-23 13:35:15 UTC

INTERFACE "Patterns" : I[Pattern] :: Pattern * Pattern [UNI]
Roles: [Role "User", Role "Tutor"]
*/
/* jshint ignore:start */
angular.module('AmpersandApp').controller('IfcPatternsController', function ($scope, $route, $routeParams, ResourceService, $location) {
    const resourceType = 'Pattern';
    const ifcName = 'Patterns';
    let resourceId;
    let resourcePath;
    let tgtId;

    // Input params
    if(resourceType == 'SESSION') {
        resourceId = '1';
        resourcePath = 'resource/SESSION/1';
        tgtId = $routeParams.resourceId; // if resourceId is specified, it is interpreted as to retreive a single tgt. Can be undefined
    } else {
        resourceId = $routeParams.resourceId;
        resourcePath = 'resource/' + resourceType + '/' + $routeParams.resourceId;
        tgtId = undefined;
    }

    $scope.resource = {
        _id_ : resourceId,
        _path_ : resourcePath,
        _isRoot_ : true,
        [ifcName] : null, // placeholder for interface data
        get : function(tgtId) {
            ResourceService.getResource(this, ifcName, this, tgtId);
        },
        save : function() {
            ResourceService.patchResource(this, true);
        }
    };
    
    $scope.patchResource = $scope.resource;
    
    // Controller functions
    $scope.switchResource = function(resourceId) {
        $location.url('/Patterns/' + resourceId);
    };
    
    // Get resource
    $scope.resource.get(tgtId);
});
/* jshint ignore:end */